import { getKeyFromPassword } from "./encryption";

function uint8ArrayToBase64(bytes: Uint8Array): string {
    return btoa(String.fromCharCode(...Array.from(bytes)));
}

export async function encryptPassword(plainText: string, password: string) {
    const enc = new TextEncoder();
    const salt = crypto.getRandomValues(new Uint8Array(16));
    const iv = crypto.getRandomValues(new Uint8Array(12));

    const key = await getKeyFromPassword(password, salt);
    const cipherBuffer = await crypto.subtle.encrypt(
        { name: "AES-GCM", iv },
        key,
        enc.encode(plainText)
    );

    return {
        cipherText: uint8ArrayToBase64(new Uint8Array(cipherBuffer)),
        iv: uint8ArrayToBase64(iv),
        salt: uint8ArrayToBase64(salt),
    };
}